import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Modal } from 'reactstrap';
import { getChildrenReduxState, ON_ADD_ITEM_TO_BASKET, ON_CLEAR_BASKET, ON_SET_CHECKOUT_MODE } from '../../pages/children';
import { TextField } from '@material-ui/core';
import { IoMdArrowRoundBack } from 'react-icons/io';
import { CheckoutMode, ROUTES } from '../../constants';
import { OldButton } from '../common';
import { getAuthReduxState } from '../../pages/auth';
import { push } from 'connected-react-router';
import { toastError } from '../../utils';
import FeatureFlagService, {
  CHUR_1979_VAT_WEB_SHOPIFY_CART_LOGIC,
} from '../../services/FeatureFlag';
import { calculateBulkDonationTotal } from '../../services/shopify';

export interface IProps {
  isVisible: boolean;
  setIsVisible: VoidFunction;
}

export const ExpressSponsorshipModal: React.FC<IProps> = ({ isVisible, setIsVisible }) => {

      const dispatch = useDispatch();
      const { basket } = useSelector(getChildrenReduxState);

      const INT_GREATER_THAN_ZERO_REGEX = /^$|^[1-9]\d*$/;  
      const { orgInfo } = useSelector(getAuthReduxState);

      const { childDonationAmount } = orgInfo;
      const [bulkNumChildren, setBulkNumChildren] = useState('');
      const [bulkDonationTotal, setBulkDonationTotal] = useState('');
      const [isShopifyCartLogicEnabled, setIsShopifyCartLogicEnabled] = useState(false);

      useEffect(() => {
        const readFlag = () => {
          setIsShopifyCartLogicEnabled(
            FeatureFlagService.getFlag(CHUR_1979_VAT_WEB_SHOPIFY_CART_LOGIC, false) === true
          );
        };

        const unsubscribe = FeatureFlagService.subscribeToEvaluations(readFlag);
        if (FeatureFlagService.isReady()) {
          readFlag();
        }

        return unsubscribe;
      }, []);

      const bulkDonationNumber = parseInt(bulkNumChildren || '0');
      const isSubmitDisabled = isShopifyCartLogicEnabled
        ? bulkDonationNumber < 1
        : bulkDonationTotal === '';

      const onNumberOfChildrenChange = (value: string) => {
        if (!INT_GREATER_THAN_ZERO_REGEX.test(value)) {
          return;
        }
        setBulkNumChildren(value);
        const numChildren = parseInt(value || '0');
        if (isShopifyCartLogicEnabled) {
          setBulkDonationTotal(
            numChildren > 0
              ? calculateBulkDonationTotal(numChildren, childDonationAmount)
              : ''
          );
        } else {
          setBulkDonationTotal(
            numChildren > 0 ? String(Math.floor(childDonationAmount * numChildren)) : ''
          );
        }
      };

      const onDonationTotalChange = (value: string) => {
        if (!INT_GREATER_THAN_ZERO_REGEX.test(value)) {
          return;
        }
        setBulkDonationTotal(value);
        setBulkNumChildren(
          String(Math.floor(parseInt(value || '0') / childDonationAmount))
        );
      };

      const onSponsorXChildrenSubmit = () => {
        if (!isShopifyCartLogicEnabled && parseInt(bulkDonationTotal || '0') < childDonationAmount) {
          toastError(`Please enter a total of $${childDonationAmount} or more.`);
          return;
        }

        dispatch(
          ON_ADD_ITEM_TO_BASKET({
            data: { bulkDonationNumber, bulkDonationTotal, id: 0 },
          })
        );
    
        const url = ROUTES.REVIEW_BASKET.path;
        dispatch(push(url));
        dispatch(ON_SET_CHECKOUT_MODE(CheckoutMode.BULK_DONATION));
        setIsVisible();
      };
    
      return (
        <Modal
          isOpen={isVisible}
          className="checkout-mode-modal"
          backdrop
        >
          <div className="checkout-mode-options-modal">
            <h2>How many children would you like to sponsor?</h2>
            <h4>For {orgInfo.orgName}</h4>
            <div className="detail-group">
              <div className="detail-section">
                <div className="option-group">
                  <label className="label-sponsor">Number of Children</label>{' '}
                  <TextField
                    value={bulkNumChildren}
                    className="textField"
                    label=" "
                    variant="standard"
                    focused
                    onChange={(e) => onNumberOfChildrenChange(e.target.value)}
                  />
                  <label className="label-sponsor">
                    &nbsp;&nbsp;= &nbsp;&nbsp;
                  </label>{' '}
                  <label className="label-dollar">$</label>
                  <TextField
                    value={bulkDonationTotal}
                    className="textField textField--total"
                    label=" "
                    variant="standard"
                    focused
                    InputProps={isShopifyCartLogicEnabled ? { readOnly: true } : undefined}
                    onChange={
                      isShopifyCartLogicEnabled
                        ? undefined
                        : (e) => onDonationTotalChange(e.target.value)
                    }
                  />
                </div>
                <div className="btn-submit">
                  <div className="icon-back">
                    <IoMdArrowRoundBack
                      onClick={() => {
                    if (basket.length > 0) {
                      dispatch(ON_CLEAR_BASKET());
                      dispatch(
                        ON_SET_CHECKOUT_MODE(CheckoutMode.SPECIFIC_CHILDREN)
                      );
                      setIsVisible();
                    }
                    dispatch(
                      ON_SET_CHECKOUT_MODE(CheckoutMode.SPECIFIC_CHILDREN)
                    );
                    setIsVisible();
                  }}
                />
              </div>
              <OldButton
                disabled={isSubmitDisabled}
                text="Submit"
                className="submit"
                onClick={onSponsorXChildrenSubmit}
              >
                Submit
              </OldButton>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default ExpressSponsorshipModal
